import styled from "@emotion/styled";
import { Dialog } from "@mui/material";

interface ICustomizedDialogWrapper { }

export const CustomizedDialogWrapper = styled(Dialog) <ICustomizedDialogWrapper>`
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(5px);

  .MuiDialog-paper {
    background-color: var(--secondary-theme-color);
    border-radius: 49px;
    /* width: 430px; */
    max-width: 750px;
    min-width: 400px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
  }
  @media screen and (max-width: 640px) {
    & .MuiDialog-paper {
      margin: 5px;
      width: 95%;
      min-width: 300px;
    }
  }
  @media (min-width: 640px) and (max-width: 1024px) {
    & .MuiDialog-paper {
      width: 40rem;
    }
  }
`;
